import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { AuthenticationService } from '..';

@Injectable()
export class PermissionsService {
    constructor(private _ccAuth: AuthenticationService) { }

    public hasApproverRole(): boolean {
        if (this._ccAuth.getSession()) {
            let roles: any = this._ccAuth.getSession().userRolesForApplication;
            return roles.toLowerCase().indexOf('approver') !== -1;
        }
        return false;
    }
    public hasRoles(role: string): boolean {
        if (this._ccAuth.getSession()) {
            let roles: any = this._ccAuth.getSession().userRolesForApplication;
            roles = roles.split("|");
            let result: boolean = false;
            _.each(role.split("|"), r => {
                if (roles.includes(r))
                    result = true;
            });
            return result;
        }
        return false;
    }
    public hasExternalApproverReviewerRoles(): boolean { 
        let result: boolean = false;
        if (this._ccAuth.getSession()) {
            let roles: any = this._ccAuth.getSession().userRolesForApplication;
            roles = roles.split("|");
            _.each(roles, r => {
                if (r.includes('APPROVER') && r != 'APPROVER' || r.includes('REVIEWER')) { 
                    result = true;
                    return false;
                }
            });
        }
        return result;
    }
    public isInternal(): boolean {
        if (this._ccAuth.getSession()) {
            return this._ccAuth.getSession().internalUser ?? false;
        }
        return false;
    }

    public getUserId(): any {
        if (this._ccAuth.getSession()) {
            return this._ccAuth.getSession().userId;
        }
    }

    public getCurrentSession(): any {
        if (this._ccAuth.getSession()) {
            return this._ccAuth.getSession();
        }
    }

    public getUserName(): any {
        if (this._ccAuth.getSession()) {
            return this._ccAuth.getSession().userName;
        }
    }

    public getCorpCommonSessionInfo(): any {
        const currentSession = this._ccAuth.getSession();
        if (currentSession) {
            let corpCommonSessionInfo: any = {};
            corpCommonSessionInfo.corpUn = currentSession.userId;
            corpCommonSessionInfo.corpAuthToken = currentSession.guid;
            corpCommonSessionInfo.appId = currentSession.applicationID;
            return corpCommonSessionInfo;
        }
    }
}